import { render, staticRenderFns } from "./DownloadReportModal.vue?vue&type=template&id=70d7282d&"
import script from "./DownloadReportModal.vue?vue&type=script&lang=js&"
export * from "./DownloadReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports